var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20831 14.144H13.7923C13.9843 14.144 14.1443 13.984 14.1443 13.792V12.928H1.85631V13.792C1.85631 14.016 2.01631 14.144 2.20831 14.144ZM14.7203 3.90397C14.1763 3.90397 13.7603 4.31997 13.7603 4.86397C13.7603 5.11997 13.8563 5.37597 14.0483 5.53597L11.1683 8.47997L8.44831 3.61597C8.73631 3.45597 8.92831 3.13597 8.92831 2.78397C8.92831 2.23997 8.51231 1.82397 7.96831 1.82397C7.42431 1.82397 7.00831 2.23997 7.00831 2.78397C7.00831 3.13597 7.20031 3.45597 7.48831 3.61597L4.76831 8.47997L1.88831 5.53597C2.14431 5.37597 2.24031 5.11997 2.24031 4.86397C2.24031 4.31997 1.82431 3.90397 1.28031 3.90397C0.736312 3.90397 0.320312 4.31997 0.320312 4.86397C0.320312 5.40797 0.736312 5.82397 1.28031 5.82397C1.31231 5.82397 1.34431 5.82397 1.34431 5.82397L1.85631 12.352H14.1443L14.6563 5.82397C14.6883 5.82397 14.7203 5.82397 14.7203 5.82397C15.2643 5.82397 15.6803 5.40797 15.6803 4.86397C15.6803 4.35197 15.2643 3.90397 14.7203 3.90397Z",
    fill: "#43474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.10fd7588dd74a05ec75f653570c90d8c.svg";
export { ForwardRef as ReactComponent };